/**
 * Admin middleware tags (Client-safe)
 *
 * This file contains only the RpcMiddleware.Tag declarations for admin endpoints.
 * These have no server-side dependencies and can be safely imported by client packages.
 *
 * @since 1.0.0
 */
import { RpcMiddleware } from "@effect/rpc";
import { Schema } from "effect";

import { CurrentActor } from "./auth.tags.ts";
import { Forbidden, Unauthorized } from "./errors.ts";

// ============================================================================
// Middleware Tag
// ============================================================================

/**
 * Admin authentication middleware tag
 *
 * Verifies Clerk session tokens AND checks for admin role.
 * Combines authentication with admin authorization in a single middleware.
 *
 * @since 1.0.0
 */
export class AdminMiddleware extends RpcMiddleware.Tag<AdminMiddleware>()(
  "AdminMiddleware",
  {
    provides: CurrentActor,
    failure: Schema.Union(Unauthorized, Forbidden),
  },
) {}
